<h1 style="font-family: 'Open Sans'; font-weight: 800">Apps</h1>
<div fxLayout="row" fxLayoutGap="50px">
  <app-app-card></app-app-card>
</div>